export function dizionarioTraduzioni(lingua,testo){
    const traduzioni={"Lezioni": {
    "1": "Lezioni",
    "2": "Lessons",
    "3": "Unterricht",
    "4": "Lecciones",
    "5": "Leçons"
  },
  "Noleggi": {
    "1": "Noleggi",
    "2": "Rentals",
    "3": "Vermietungen",
    "4": "Alquileres",
    "5": "Locations"
  },
  "Storage": {
    "1": "Storage",
    "2": "Storage",
    "3": "Lagerung",
    "4": "Almacenamiento",
    "5": "Stockage"
  },
  "Riparazioni": {
    "1": "Riparazioni",
    "2": "Repairs",
    "3": "Reparaturen",
    "4": "Reparaciones",
    "5": "Réparations"
  },
  "Escursioni": {
    "1": "Escursioni",
    "2": "Excursions",
    "3": "Ausflüge",
    "4": "Excursiones",
    "5": "Excursions"
  },
  "Spese": {
    "1": "Spese",
    "2": "Expenses",
    "3": "Ausgaben",
    "4": "Gastos",
    "5": "Dépenses"
  },
  "Conti": {
    "1": "Conti",
    "2": "Accounts",
    "3": "Konten",
    "4": "Cuentas",
    "5": "Comptes"
  },
  "Fatture": {
    "1": "Fatture",
    "2": "Invoices",
    "3": "Rechnungen",
    "4": "Facturas",
    "5": "Factures"
  },
    "Inizio periodo": {
    "1": "Inizio periodo",
    "2": "Start period",
    "3": "Beginn des Zeitraums",
    "4": "Inicio del período",
    "5": "Début de la période"
  },
  "Fine periodo": {
    "1": "Fine periodo",
    "2": "End period",
    "3": "Ende des Zeitraums",
    "4": "Fin del período",
    "5": "Fin de la période"
  },
    "Tutti": {
    "1": "Tutti",
    "2": "All",
    "3": "Alle",
    "4": "Todos",
    "5": "Tous"
  },
  "Pacchetti Conclusi": {
    "1": "Pacchetti Conclusi",
    "2": "Completed Packages",
    "3": "Abgeschlossene Pakete",
    "4": "Paquetes Completados",
    "5": "Forfaits Terminés"
  },
  "Pacchetti Aperti": {
    "1": "Pacchetti Aperti",
    "2": "Open Packages",
    "3": "Offene Pakete",
    "4": "Paquetes Abiertos",
    "5": "Forfaits Ouverts"
  },
  "Data": {
    "1": "Data",
    "2": "Date",
    "3": "Datum",
    "4": "Fecha",
    "5": "Date"
  },
  "Studente": {
    "1": "Studente",
    "2": "Student",
    "3": "Student",
    "4": "Estudiante",
    "5": "Étudiant"
  },
  "Pacchetto": {
    "1": "Pacchetto",
    "2": "Package",
    "3": "Paket",
    "4": "Paquete",
    "5": "Forfait"
  },
  "Tipo": {
    "1": "Tipo",
    "2": "Type",
    "3": "Typ",
    "4": "Tipo",
    "5": "Type"
  },
  "Num": {
    "1": "Num",
    "2": "Num",
    "3": "Num",
    "4": "Núm",
    "5": "Num"
  },
  "Costo": {
    "1": "Costo",
    "2": "Cost",
    "3": "Kosten",
    "4": "Costo",
    "5": "Coût"
  },
  "Anticipo": {
    "1": "Anticipo",
    "2": "Deposit",
    "3": "Anzahlung",
    "4": "Anticipo",
    "5": "Acompte"
  },
  "Pagamento": {
    "1": "Pagamento",
    "2": "Payment",
    "3": "Zahlung",
    "4": "Pago",
    "5": "Paiement"
  },
  "Nazionalità allievo": {
    "1": "Nazionalità allievo",
    "2": "Student nationality",
    "3": "Nationalität des Schülers",
    "4": "Nacionalidad del alumno",
    "5": "Nationalité de l'élève"
  },
  "Periodo": {
    "1": "Periodo",
    "2": "Period",
    "3": "Zeitraum",
    "4": "Período",
    "5": "Période"
  },
  "Arrivo": {
    "1": "Arrivo",
    "2": "Arrival",
    "3": "Ankunft",
    "4": "Llegada",
    "5": "Arrivée"
  },
  "Partenza": {
    "1": "Partenza",
    "2": "Departure",
    "3": "Abreise",
    "4": "Salida",
    "5": "Départ"
  },
  "Date non disponibili": {
    "1": "Date non disponibili",
    "2": "Unavailable dates",
    "3": "Nicht verfügbare Daten",
    "4": "Fechas no disponibles",
    "5": "Dates non disponibles"
  },
  "Età allievo": {
    "1": "Età allievo",
    "2": "Student age",
    "3": "Alter des Schülers",
    "4": "Edad del alumno",
    "5": "Âge de l'élève"
  },
  "Genere allievo": {
    "1": "Genere allievo",
    "2": "Student gender",
    "3": "Geschlecht des Schülers",
    "4": "Género del alumno",
    "5": "Genre de l'élève"
  },
  "Non specificato": {
    "1": "Non specificato",
    "2": "Not specified",
    "3": "Nicht angegeben",
    "4": "No especificado",
    "5": "Non spécifié"
  },
  "Uomo": {
    "1": "Uomo",
    "2": "Male",
    "3": "Männlich",
    "4": "Hombre",
    "5": "Homme"
  },
  "Donna": {
    "1": "Donna",
    "2": "Female",
    "3": "Weiblich",
    "4": "Mujer",
    "5": "Femme"
  },
  "Numero allievo": {
    "1": "Numero allievo",
    "2": "Student number",
    "3": "Schülernummer",
    "4": "Número de alumno",
    "5": "Numéro d'élève"
  },
  "sconto": {
    "1": "Sconto",
    "2": "Discount",
    "3": "Rabatt",
    "4": "Descuento",
    "5": "Réduction"
  },
  "Informazioni studente": {
    "1": "Informazioni studente",
    "2": "Student information",
    "3": "Schülerinformationen",
    "4": "Información del estudiante",
    "5": "Informations sur l'étudiant"
  },
  "Dettagli lezioni": {
    "1": "Dettagli lezioni",
    "2": "Lesson details",
    "3": "Unterrichtsdetails",
    "4": "Detalles de las clases",
    "5": "Détails des leçons"
  },
  "Modifica": {
    "1": "Modifica",
    "2": "Edit",
    "3": "Bearbeiten",
    "4": "Modificar",
    "5": "Modifier"
  },
  "Elimina": {
    "1": "Elimina",
    "2": "Delete",
    "3": "Löschen",
    "4": "Eliminar",
    "5": "Supprimer"
  },
  "Chiudi pacchetto": {
    "1": "Chiudi pacchetto",
    "2": "Close package",
    "3": "Paket schließen",
    "4": "Cerrar paquete",
    "5": "Fermer le forfait"
  },
  "Fattura pacchetto": {
    "1": "Fattura pacchetto",
    "2": "Invoice package",
    "3": "Paketrechnung",
    "4": "Facturar paquete",
    "5": "Facturer le forfait"
  },
  "Costo scontato": {
    "1": "Costo scontato",
    "2": "Discounted cost",
    "3": "Reduzierter Preis",
    "4": "Costo descontado",
    "5": "Coût réduit"
  },
  "Sconto (%)": {
    "1": "Sconto (%)",
    "2": "Discount (%)",
    "3": "Rabatt (%)",
    "4": "Descuento (%)",
    "5": "Réduction (%)"
  },
  "Pagato (€)": {
    "1": "Pagato (€)",
    "2": "Paid (€)",
    "3": "Bezahlt (€)",
    "4": "Pagado (€)",
    "5": "Payé (€)"
  },
  "Costo (€)": {
    "1": "Costo (€)",
    "2": "Cost (€)",
    "3": "Kosten (€)",
    "4": "Costo (€)",
    "5": "Coût (€)"
  },
  "Pacchetto (H)": {
    "1": "Pacchetto (H)",
    "2": "Package (H)",
    "3": "Paket (H)",
    "4": "Paquete (H)",
    "5": "Forfait (H)"
  },
  "Suddivisione nazionalità": {
    "1": "Suddivisione nazionalità",
    "2": "Nationality breakdown",
    "3": "Nationalitätsverteilung",
    "4": "Distribución por nacionalidad",
    "5": "Répartition par nationalité"
  },
  "Suddivisione genere": {
    "1": "Suddivisione genere",
    "2": "Gender breakdown",
    "3": "Geschlechterverteilung",
    "4": "Distribución por género",
    "5": "Répartition par genre"
  },
  "Categoria": {
    "1": "Categoria",
    "2": "Category",
    "3": "Kategorie",
    "4": "Categoría",
    "5": "Catégorie"
  },
  "Valore": {
    "1": "Valore",
    "2": "Value",
    "3": "Wert",
    "4": "Valor",
    "5": "Valeur"
  },
  "Percentuale": {
    "1": "Percentuale",
    "2": "Percentage",
    "3": "Prozentsatz",
    "4": "Porcentaje",
    "5": "Pourcentage"
  },
  "persone": {
    "1": "Persone",
    "2": "People",
    "3": "Personen",
    "4": "Personas",
    "5": "Personnes"
  },
  "Gestisci conto": {
    "1": "Gestisci conto",
    "2": "Manage account",
    "3": "Konto verwalten",
    "4": "Gestionar cuenta",
    "5": "Gérer le compte"
  },
  "Sei sicuro di volere chiudere il pacchetto di": {
    "1": "Sei sicuro di volere chiudere il pacchetto di",
    "2": "Are you sure you want to close the package of",
    "3": "Bist du sicher, dass du das Paket schließen willst von",
    "4": "¿Seguro que quieres cerrar el paquete de",
    "5": "Êtes-vous sûr de vouloir fermer le forfait de"
  },
  "Conferma chiusura pacchetto di": {
    "1": "Conferma chiusura pacchetto di",
    "2": "Confirm package closure of",
    "3": "Bestätige das Schließen des Pakets von",
    "4": "Confirmar cierre del paquete de",
    "5": "Confirmer la fermeture du forfait de"
  },
  "Salva": {
    "1": "Salva",
    "2": "Save",
    "3": "Speichern",
    "4": "Guardar",
    "5": "Enregistrer"
  },
  "Chiudi": {
    "1": "Chiudi",
    "2": "Close",
    "3": "Schließen",
    "4": "Cerrar",
    "5": "Fermer"
  },
  "Salva fattura": {
    "1": "Salva fattura",
    "2": "Save invoice",
    "3": "Rechnung speichern",
    "4": "Guardar factura",
    "5": "Enregistrer la facture"
  },
  "Modifica intestazione": {
    "1": "Modifica intestazione",
    "2": "Edit header",
    "3": "Kopfzeile bearbeiten",
    "4": "Modificar encabezado",
    "5": "Modifier l'en-tête"
  },
  "Nome Fattura": {
    "1": "Nome Fattura",
    "2": "Invoice name",
    "3": "Rechnungsname",
    "4": "Nombre de factura",
    "5": "Nom de facture"
  },
  "Indirizzo cliente": {
    "1": "Indirizzo cliente",
    "2": "Client address",
    "3": "Kundenadresse",
    "4": "Dirección del cliente",
    "5": "Adresse du client"
  },
  "contatti cliente": {
    "1": "Contatti cliente",
    "2": "Client contacts",
    "3": "Kundenkontakte",
    "4": "Contactos del cliente",
    "5": "Contacts client"
  },
  "Note fattura": {
    "1": "Note fattura",
    "2": "Invoice notes",
    "3": "Rechnungsnotizen",
    "4": "Notas de factura",
    "5": "Notes de facture"
  },
  "Numero fattura": {
    "1": "Numero fattura",
    "2": "Invoice number",
    "3": "Rechnungsnummer",
    "4": "Número de factura",
    "5": "Numéro de facture"
  },
  "Modifica righe": {
    "1": "Modifica righe",
    "2": "Edit rows",
    "3": "Zeilen bearbeiten",
    "4": "Editar filas",
    "5": "Modifier les lignes"
  },
  "Descrizione": {
    "1": "Descrizione",
    "2": "Description",
    "3": "Beschreibung",
    "4": "Descripción",
    "5": "Description"
  },
  "Quantità": {
    "1": "Quantità",
    "2": "Quantity",
    "3": "Menge",
    "4": "Cantidad",
    "5": "Quantité"
  },
  "Valuta": {
    "1": "Valuta",
    "2": "Currency",
    "3": "Währung",
    "4": "Moneda",
    "5": "Devise"
  },
  "Costo unitario": {
    "1": "Costo unitario",
    "2": "Unit cost",
    "3": "Stückpreis",
    "4": "Costo unitario",
    "5": "Coût unitaire"
  },
  "Costo netto totale": {
    "1": "Costo netto totale",
    "2": "Total net cost",
    "3": "Gesamtnettokosten",
    "4": "Costo neto total",
    "5": "Coût net total"
  },
  "Pagato": {
    "1": "Pagato",
    "2": "Paid",
    "3": "Bezahlt",
    "4": "Pagado",
    "5": "Payé"
  },
  "Dettagli lezioni di": {
    "1": "Dettagli lezioni di",
    "2": "Lesson details of",
    "3": "Unterrichtsdetails von",
    "4": "Detalles de las clases de",
    "5": "Détails des leçons de"
  },
  "Ore concluse": {
    "1": "Ore concluse",
    "2": "Completed hours",
    "3": "Abgeschlossene Stunden",
    "4": "Horas completadas",
    "5": "Heures terminées"
  },
  "Ore Programmate": {
    "1": "Ore Programmate",
    "2": "Scheduled hours",
    "3": "Geplante Stunden",
    "4": "Horas programadas",
    "5": "Heures programmées"
  },
  "Data e ora inizio": {
    "1": "Data e ora inizio",
    "2": "Start date and time",
    "3": "Startdatum und -uhrzeit",
    "4": "Fecha y hora de inicio",
    "5": "Date et heure de début"
  },
  "Data e ora fine": {
    "1": "Data e ora fine",
    "2": "End date and time",
    "3": "Enddatum und -uhrzeit",
    "4": "Fecha y hora de fin",
    "5": "Date et heure de fin"
  },
  "Durata lezione": {
    "1": "Durata lezione",
    "2": "Lesson duration",
    "3": "Unterrichtsdauer",
    "4": "Duración de la clase",
    "5": "Durée de la leçon"
  },
  "Istruttore": {
    "1": "Istruttore",
    "2": "Instructor",
    "3": "Lehrer",
    "4": "Instructor",
    "5": "Instructeur"
  },
  "Status Lezione": {
    "1": "Status Lezione",
    "2": "Lesson status",
    "3": "Unterrichtsstatus",
    "4": "Estado de la clase",
    "5": "Statut de la leçon"
  },
  "Programmata": {
    "1": "Programmata",
    "2": "Scheduled",
    "3": "Geplant",
    "4": "Programada",
    "5": "Programmée"
  },
  "Conclusa": {
    "1": "Conclusa",
    "2": "Completed",
    "3": "Abgeschlossen",
    "4": "Completada",
    "5": "Terminée"
  },
  "Cancellata": {
    "1": "Cancellata",
    "2": "Cancelled",
    "3": "Storniert",
    "4": "Cancelada",
    "5": "Annulée"
  },
  "No Show": {
    "1": "No Show",
    "2": "No Show",
    "3": "Nicht erschienen",
    "4": "No Show",
    "5": "No Show"
  },
  "Livello raggiunto": {
    "1": "Livello raggiunto",
    "2": "Level achieved",
    "3": "Erreichtes Level",
    "4": "Nivel alcanzado",
    "5": "Niveau atteint"
  },
  "Modifica lezione di": {
    "1": "Modifica lezione di",
    "2": "Edit lesson of",
    "3": "Unterricht bearbeiten von",
    "4": "Modificar clase de",
    "5": "Modifier la leçon de"
  },
        "Fattura": {
    "1": "Fattura",
    "2": "Invoice",
    "3": "Rechnung",
    "4": "Factura",
    "5": "Facture"
  },
"Base": {
    "1": "Base",
    "2": "Basic",
    "3": "Basis",
    "4": "Básico",
    "5": "Base"
  },
  "Avanzata": {
    "1": "Avanzata",
    "2": "Advanced",
    "3": "Fortgeschritten",
    "4": "Avanzado",
    "5": "Avancé"
  },
  "Foil": {
    "1": "Foil",
    "2": "Foil",
    "3": "Foil",
    "4": "Foil",
    "5": "Foil"
  },
         "Ore totali di__prefix": {
    "1": "Ore totali di",
    "2": "Total hours of",
    "3": "Gesamtstunden von",
    "4": "Horas totales de",
    "5": "Heures totales de"
  },
  "Ore totali di__middle": {
    "1": "di cui",
    "2": "including",
    "3": "davon",
    "4": "de las cuales",
    "5": "dont"
  },
  "Ore totali di__completed": {
    "1": "concluse",
    "2": "completed",
    "3": "abgeschlossen",
    "4": "completadas",
    "5": "terminées"
  },
         "e": {
    "1": "e",
    "2": "and",
    "3": "und",
    "4": "y",
    "5": "et"
  },
  "Ore totali di__scheduled": {
    "1": "programmate",
    "2": "scheduled",
    "3": "geplant",
    "4": "programadas",
    "5": "programmées"
  },
       "Ore totali di short__prefix": {
    "1": "Ore totali di",
    "2": "Total hours of",
    "3": "Gesamtstunden von",
    "4": "Horas totales de",
    "5": "Heures totales de"
  },
        "Lezione aggiunta__prefix": {
    "1": "Lezione di",
    "2": "Lesson for",
    "3": "Unterricht für",
    "4": "Lección de",
    "5": "Leçon de"
  },
  "Lezione aggiunta__suffix": {
    "1": "aggiunta con successo",
    "2": "added successfully",
    "3": "erfolgreich hinzugefügt",
    "4": "añadida con éxito",
    "5": "ajoutée avec succès"
  },
        "dal": {
    "1": "dal",
    "2": "from",
    "3": "vom",
    "4": "desde",
    "5": "du"
  },
  "al": {
    "1": "al",
    "2": "to",
    "3": "bis",
    "4": "hasta",
    "5": "au"
  },
"Non definito": {
    "1": "Non definito",
    "2": "Undefined",
    "3": "Nicht definiert",
    "4": "No definido",
    "5": "Non défini"
  },
  "Italia": {
    "1": "Italia",
    "2": "Italy",
    "3": "Italien",
    "4": "Italia",
    "5": "Italie"
  },
  "Francia": {
    "1": "Francia",
    "2": "France",
    "3": "Frankreich",
    "4": "Francia",
    "5": "France"
  },
  "Germania": {
    "1": "Germania",
    "2": "Germany",
    "3": "Deutschland",
    "4": "Alemania",
    "5": "Allemagne"
  },
  "Spagna": {
    "1": "Spagna",
    "2": "Spain",
    "3": "Spanien",
    "4": "España",
    "5": "Espagne"
  },
  "Olanda": {
    "1": "Olanda",
    "2": "Netherlands",
    "3": "Niederlande",
    "4": "Países Bajos",
    "5": "Pays-Bas"
  },
  "Svizzera": {
    "1": "Svizzera",
    "2": "Switzerland",
    "3": "Schweiz",
    "4": "Suiza",
    "5": "Suisse"
  },
  "Nairobi": {
    "1": "Nairobi",
    "2": "Nairobi",
    "3": "Nairobi",
    "4": "Nairobi",
    "5": "Nairobi"
  },
  "Austria": {
    "1": "Austria",
    "2": "Austria",
    "3": "Österreich",
    "4": "Austria",
    "5": "Autriche"
  },
  "Paesi Bassi": {
    "1": "Paesi Bassi",
    "2": "Netherlands",
    "3": "Niederlande",
    "4": "Países Bajos",
    "5": "Pays-Bas"
  },
  "Gran Bretagna": {
    "1": "Gran Bretagna",
    "2": "United Kingdom",
    "3": "Vereinigtes Königreich",
    "4": "Reino Unido",
    "5": "Royaume-Uni"
  },
"Seleziona extra": {
    "1": "Seleziona extra",
    "2": "Select extra",
    "3": "Extra auswählen",
    "4": "Seleccionar extra",
    "5": "Sélectionner extra"
  },
  "Camere e Ospiti": {
    "1": "Camere e Ospiti",
    "2": "Rooms and Guests",
    "3": "Zimmer und Gäste",
    "4": "Habitaciones y Huéspedes",
    "5": "Chambres et invités"
  },
  "Camera N": {
    "1": "Camera N",
    "2": "Room N",
    "3": "Zimmer N",
    "4": "Habitación N",
    "5": "Chambre N"
  },
  "Nome": {
    "1": "Nome",
    "2": "First Name",
    "3": "Vorname",
    "4": "Nombre",
    "5": "Prénom"
  },
  "Cognome": {
    "1": "Cognome",
    "2": "Last Name",
    "3": "Nachname",
    "4": "Apellido",
    "5": "Nom de famille"
  },
  "Data di Nascita": {
    "1": "Data di Nascita",
    "2": "Date of Birth",
    "3": "Geburtsdatum",
    "4": "Fecha de Nacimiento",
    "5": "Date de naissance"
  },
  "Luogo di Nascita": {
    "1": "Luogo di Nascita",
    "2": "Place of Birth",
    "3": "Geburtsort",
    "4": "Lugar de Nacimiento",
    "5": "Lieu de naissance"
  },
  "Genere": {
    "1": "Genere",
    "2": "Gender",
    "3": "Geschlecht",
    "4": "Género",
    "5": "Sexe"
  },
  "Nazionalità": {
    "1": "Nazionalità",
    "2": "Nationality",
    "3": "Nationalität",
    "4": "Nacionalidad",
    "5": "Nationalité"
  },
  "tipo Documento": {
    "1": "Tipo Documento",
    "2": "Document Type",
    "3": "Dokumenttyp",
    "4": "Tipo de Documento",
    "5": "Type de Document"
  },
  "Numero Documento": {
    "1": "Numero Documento",
    "2": "Document Number",
    "3": "Dokumentennummer",
    "4": "Número de Documento",
    "5": "Numéro de Document"
  },
  "Tipo Costo": {
    "1": "Tipo Costo",
    "2": "Cost Type",
    "3": "Kostenart",
    "4": "Tipo de Costo",
    "5": "Type de Coût"
  },
  "Al giorno": {
    "1": "Al giorno",
    "2": "Per Day",
    "3": "Pro Tag",
    "4": "Por Día",
    "5": "Par Jour"
  },
  "Totale": {
    "1": "Totale",
    "2": "Total",
    "3": "Gesamt",
    "4": "Total",
    "5": "Total"
  },
  "Aggiungi camera": {
    "1": "Aggiungi camera",
    "2": "Add Room",
    "3": "Zimmer hinzufügen",
    "4": "Agregar habitación",
    "5": "Ajouter chambre"},
        "Passaporto": {
  "1": "Passaporto",
  "2": "Passport",
  "3": "Reisepass",
  "4": "Pasaporte",
  "5": "Passeport"
},
"Carta d'identità": {
  "1": "Carta d'identità",
  "2": "ID Card",
  "3": "Personalausweis",
  "4": "Documento de identidad",
  "5": "Carte d'identité"
},
"Patente": {
  "1": "Patente",
  "2": "Driving License",
  "3": "Führerschein",
  "4": "Licencia de conducir",
  "5": "Permis de conduire"
},
        "Modifica ospite": {
  "1": "Modifica ospite",
  "2": "Edit Guest",
  "3": "Gast bearbeiten",
  "4": "Editar huésped",
  "5": "Modifier invité"
},
"Nome Prenotazione": {
  "1": "Nome Prenotazione",
  "2": "Booking Name",
  "3": "Buchungsname",
  "4": "Nombre de la Reserva",
  "5": "Nom de la Réservation"
},
        "Notti": {
  "1": "Notti",
  "2": "Nights",
  "3": "Nächte",
  "4": "Noches",
  "5": "Nuits"
},
        "Costo Totale": {
  "1": "Costo Totale",
  "2": "Total Cost",
  "3": "Gesamtkosten",
  "4": "Costo Total",
  "5": "Coût Total"
},
        "Agenda Prenotazioni": {
  "1": "Agenda Prenotazioni",
  "2": "Booking Agenda",
  "3": "Buchungsplan",
  "4": "Agenda de Reservas",
  "5": "Agenda des Réservations"
},
        "Metodo di Pagamento": {
  "1": "Metodo di Pagamento",
  "2": "Payment Method",
  "3": "Zahlungsmethode",
  "4": "Método de Pago",
  "5": "Méthode de Paiement"
},
        "Data del Pagamento": {
  "1": "Data del Pagamento",
  "2": "Payment Date",
  "3": "Zahlungsdatum",
  "4": "Fecha de Pago",
  "5": "Date de Paiement"
},
"Seleziona Struttura": {
  "1": "Seleziona Struttura",
  "2": "Select Property",
  "3": "Struktur auswählen",
  "4": "Seleccionar estructura",
  "5": "Sélectionner la structure"
},
        "Informazioni prenotazione": {
  "1": "Informazioni prenotazione",
  "2": "Booking Information",
  "3": "Buchungsinformationen",
  "4": "Información de la reserva",
  "5": "Informations de réservation"
},

"Dettagli prenotazione di": {
  "1": "Dettagli prenotazione di",
  "2": "Booking details of",
  "3": "Buchungsdetails von",
  "4": "Detalles de la reserva de",
  "5": "Détails de la réservation de"
},
        "Data check-in": {
  "1": "Data check-in",
  "2": "Check-in Date",
  "3": "Check-in-Datum",
  "4": "Fecha de check-in",
  "5": "Date d’arrivée"
},

"Data check-out": {
  "1": "Data check-out",
  "2": "Check-out Date",
  "3": "Check-out-Datum",
  "4": "Fecha de check-out",
  "5": "Date de départ"
},

"Note prenotazione": {
  "1": "Note prenotazione",
  "2": "Booking notes",
  "3": "Buchungshinweise",
  "4": "Notas de la reserva",
  "5": "Notes de réservation"
},

"Dettagli prenotazione": {
  "1": "Dettagli prenotazione",
  "2": "Booking details",
  "3": "Buchungsdetails",
  "4": "Detalles de la reserva",
  "5": "Détails de la réservation"
},
"Categoria Spesa": {
  "1": "Categoria Spesa",
  "2": "Expense Category",
  "3": "Ausgabenkategorie",
  "4": "Categoría de gasto",
  "5": "Catégorie de dépense"
},

"Sottocategoria": {
  "1": "Sottocategoria",
  "2": "Subcategory",
  "3": "Unterkategorie",
  "4": "Subcategoría",
  "5": "Sous-catégorie"
},

"Importo spesa": {
  "1": "Importo spesa",
  "2": "Expense amount",
  "3": "Ausgabenbetrag",
  "4": "Importe del gasto",
  "5": "Montant de la dépense"
},

"Valuta spesa": {
  "1": "Valuta spesa",
  "2": "Expense currency",
  "3": "Währung",
  "4": "Moneda del gasto",
  "5": "Devise"
},

"Note spesa": {
  "1": "Note spesa",
  "2": "Expense notes",
  "3": "Ausgabennotizen",
  "4": "Notas del gasto",
  "5": "Notes de dépense"
},
        "Aggiungi categoria": {
  "1": "Aggiungi categoria",
  "2": "Add category",
  "3": "Kategorie hinzufügen",
  "4": "Agregar categoría",
  "5": "Ajouter une catégorie"
},
        "Aggiungi": {
  "1": "Aggiungi",
  "2": "Add",
  "3": "Hinzufügen",
  "4": "Agregar",
  "5": "Ajouter"
},

"Modifica": {
  "1": "Modifica",
  "2": "Edit",
  "3": "Bearbeiten",
  "4": "Editar",
  "5": "Modifier"
},

"Sei sicuro di volere eliminare la": {
  "1": "Sei sicuro di volere eliminare la",
  "2": "Are you sure you want to delete the",
  "3": "Möchten Sie die wirklich löschen",
  "4": "¿Estás seguro de que deseas eliminar la",
  "5": "Êtes-vous sûr de vouloir supprimer la"
},

"Conferma eliminazione della": {
  "1": "Conferma eliminazione della",
  "2": "Confirm deletion of",
  "3": "Löschen bestätigen",
  "4": "Confirmar eliminación de la",
  "5": "Confirmer la suppression de la"
},
        "Prenotazioni": {
  "1": "Prenotazioni",
  "2": "Bookings",
  "3": "Buchungen",
  "4": "Reservas",
  "5": "Réservations"
}














    }
    if (testo in traduzioni)
    return traduzioni[testo][lingua]
    else return null
}